import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import GetTypeWiseDocuments from '@features/supplier/component/GetTypeWiseDocuments';
import AddRegulatoryDocuments from '@features/supplier/component/AddRegulatoryDocuments';
import ViewDocuments from '@features/supplier/component/ViewDocuments';

import { useSupplierDocuments } from '@store/reducers/supplier-onboarding/OnboardingReducer';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { getSupplierDocuments, removeSupplierDocuments } from '@services/supplierOnboardingService';

import { printApiError } from '@utils/Util';

const RegulatoryDocuments = () => {
	const documents = useSupplierDocuments();
	const [isShowView, setIsShowView] = useState(false);
	const [selectedDocuments, setSelectedDocuments] = useState([]);
	const [isAdd, setIsAdd] = useState(false);
	const dispatch = useDispatch();
	const { id } = useParams();

	const onRemoveDocument = async (docId) => {
		try {
			dispatch(openLoader());
			await removeSupplierDocuments(id, docId);
			setSelectedDocuments(selectedDocuments.filter((item) => item.id !== docId));
			await dispatch(getSupplierDocuments(id));
			dispatch(closeLoader());
		} catch (e) {
			dispatch(closeLoader());
			printApiError(e);
		}
	};

	const tradeLicenseList = documents['tradeLicenseList']?.sort((a, b) => b.id - a.id) || [];
	const factoryLicenseList = documents['factoryLicenseList']?.sort((a, b) => b.id - a.id) || [];
	const tinCertificateList = documents['tinCertificateList']?.sort((a, b) => b.id - a.id) || [];

	return (
		<>
			<div className="section-padding hover-section">
				<h3 className="suplier-title pb-4 font-weight-bold regular-16">
					Regulatory documents
					<span className="ml-12">
						<button
							className="blue border-0 medium-14 bg-transparent"
							onClick={() => setIsAdd(true)}
						>
							Add
						</button>
					</span>
				</h3>
				<div className="info-items_bottom">
					{tradeLicenseList?.[0] && (
						<GetTypeWiseDocuments
							documents={{ tradeLicenseList: [tradeLicenseList[0]] }}
							title="Trade License"
							fieldName="tradeLicenseList"
							isShowRemove={false}
							onViewClick={() => {
								setSelectedDocuments(tradeLicenseList);
								setIsShowView(true);
							}}
							onRemoveClick={onRemoveDocument}
						/>
					)}
					{factoryLicenseList?.[0] && (
						<GetTypeWiseDocuments
							documents={{ factoryLicenseList: [factoryLicenseList[0]] }}
							title="Factory License"
							fieldName="factoryLicenseList"
							isShowRemove={false}
							onRemoveClick={onRemoveDocument}
							onViewClick={() => {
								setSelectedDocuments(factoryLicenseList);
								setIsShowView(true);
							}}
						/>
					)}
					{tinCertificateList?.[0] && (
						<GetTypeWiseDocuments
							documents={{ tinCertificateList: [tinCertificateList[0]] }}
							title="TIN Certificate"
							fieldName="tinCertificateList"
							isShowRemove={false}
							onRemoveClick={onRemoveDocument}
							onViewClick={() => {
								setSelectedDocuments(tinCertificateList);
								setIsShowView(true);
							}}
						/>
					)}
				</div>
			</div>
			{isAdd && <AddRegulatoryDocuments documents={documents} onClose={() => setIsAdd(false)} />}
			{isShowView && (
				<ViewDocuments
					onClose={() => {
						setSelectedDocuments([]);
						setIsShowView(false);
					}}
					title="Regulatory Documents"
					onRemoveClick={onRemoveDocument}
					documentList={selectedDocuments}
				/>
			)}
		</>
	);
};

export default RegulatoryDocuments;
